import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import { computed } from "vue";
import { ProductIds } from "@/config/constants";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestone } from "@/models/applicationStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'UnderReviewText',
  emits: ["todoListClicked"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { productTypeId, timeline, emailAddress } = useApplicationStatus();

const steps = computed(() => timeline.value.filter((s: TimelineMilestone) => s.step > 1));

return (_ctx: any,_cache: any) => {
  return (_unref(productTypeId) === _unref(ProductIds).REFI)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _cache[1] || (_cache[1] = _createTextVNode("Your application is currently under review. Please see the ", -1)),
        _createElementVNode("a", {
          class: "inline-link",
          "aria-description": "link to scroll to the todo list when using a mobile device",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('todoListClicked')))
        }, "To-Do List"),
        _cache[2] || (_cache[2] = _createTextVNode(" below for information you need to provide. If no action is requested, we'll be in touch shortly with an update. If you wish to contact our processors or share the best way to get ahold of you, you can email our team directly by clicking ", -1)),
        _createElementVNode("a", {
          class: "inline-link",
          href: `mailto:${_unref(emailAddress)}`,
          "aria-description": "link to email the support team"
        }, "here", 8, _hoisted_1),
        _cache[3] || (_cache[3] = _createTextVNode(".", -1))
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "opal-alert" }, " Please check your To-Do list to see if any action is needed during this process. ", -1)),
        _createElementVNode("p", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" Your application is currently under review, and we'll be in touch shortly. If you wish to contact our processors or share the best way to get ahold of you, you can email our team directly by clicking ", -1)),
          _createElementVNode("a", {
            class: "inline-link",
            "aria-description": "link to email the support team",
            href: `mailto:${_unref(emailAddress)}`
          }, "here", 8, _hoisted_2),
          _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
        ])
      ], 64))
}
}

})